import { useFormState } from 'react-hook-form';
import { useCoordinatorForms } from '../coordinator/useCoordinatorForms.tsx';
import { useFormStateIsDirty } from '../useFormStateIsDirty.ts';
import { PreventNavigation } from './PreventNavigation.tsx';

export interface IFormPreventNavigationProps {
  /** Id del form corrente, escluso dall'aggregazione del coordinator. */
  currentFormId?: string | null;
}

/**
 * Previene la navigazione se il Form RHF è stato modificato, ovvero
 * se ci sono modifiche non salvate.
 *
 * Utilizziamo "isDirty && !isSubmitting" come condizione per evitare di essere
 * bloccati durante il salvataggio di un nuovo form prima del redirect.
 */
export function FormPreventNavigation(props: IFormPreventNavigationProps) {
  const { isSubmitting } = useFormState();

  const isFormDirty = useFormStateIsDirty();
  // Il coordinator aggrega solo gli ALTRI form (es. tab sorelle); il form
  // corrente è escluso via `currentFormId`. Il suo stato nel coordinator viene
  // aggiornato in differita da uno useEffect, quindi subito dopo un salvataggio
  // sarebbe ancora DIRTY in `coordinatorForms[formId]` mentre è già NON DIRTY
  // in `isFormDirty`: senza esclusione avremmo un prompt spurio. Per il form
  // corrente fa fede `useFormStateIsDirty()`, che è sincrono.
  const coordinatorForms = useCoordinatorForms();
  const isCoordinatorDirty = Object.entries(coordinatorForms).some(
    ([id, { isDirty }]) => id !== props.currentFormId && isDirty,
  );

  const isDirty = isFormDirty || isCoordinatorDirty;

  return <PreventNavigation when={isDirty && !isSubmitting} />;
}
